var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.SettingsTopBar,{attrs:{"pathCurrent":"Content","pathBefore":"Settings /","showBackButton":true,"backRoute":_setup.backRoute,"showSubmitButton":false}}),_c(_setup.CmsMenu,{attrs:{"menuData":_setup.menuData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }